module.exports = __webpack_public_path__ + "media/images/lb/298-fc1c7dc792ff7fe27654e495b7e93f54.svg";